import React from 'react';
import { Outlet } from 'react-router-dom';
import Navigation from 'shared/components/navigation/Navigation';
import TopNavBar from 'shared/components/navigation/TopNavBar';

const AppLayout = ()=> {
    return (
        <div style={{ display: 'flex', height: '100%'}}>
            <Navigation />
            <main style={{ width: '100%'}}>
                <TopNavBar />
                <div className="page">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}

export default AppLayout;
